export default function updateRedirectReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'PUT_REDIRECT_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'PUT_REDIRECT_ERROR':
            return {...state, ...{error: action.error}};

        case 'PUT_REDIRECT_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}